import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, User, LogOut, Settings, ChevronDown, Bell, MapPin } from 'lucide-react';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import '../../../../assets/css/customer/customerdashboard/customerLayout/customerdashboard.css';

const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);
  const [user, setUser] = useState({ name: '', email: '', avatar: '' });
  const [showDropdown, setShowDropdown] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setUser({
      name: localStorage.getItem('userName') || 'Guest User',
      email: localStorage.getItem('customerEmail') || '',
      avatar: '',
      id: localStorage.getItem('customerId') || '',
      role: localStorage.getItem('userRole') || '',
    });
  }, []);

  useEffect(() => {
    if (!authToken) return;

    axios
      .get(`${baseUrl}/customer/view-customer-notifications`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        const list = res.data?.notifications || res.data?.data || [];
        const count = list.filter((n) => n.status === 'unread').length;
        setUnreadCount(count);
      })
      .catch((err) => console.error('Notification count error:', err));
  }, [authToken, baseUrl]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getInitials = (name) => {
    if (!name || name === 'Guest User') return 'GU';
    return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  };

  const handleLogout = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("customerEmail");
  localStorage.removeItem("customerPassword");
  localStorage.removeItem("userRole");
  localStorage.removeItem("customerId");
  localStorage.removeItem("userName");

  navigate("/auth/login", { replace: true });
};

  return (
    <div className="cus-hdr-dashboard-header">
      <div className="cus-hdr-header-content">

        <div className="cus-hdr-header-left">
          <button
            className="cus-hdr-mobile-menu-btn cus-hdr-header-icon-btn d-lg-none"
            onClick={toggleSidebar}
          >
            <Menu size={20} />
          </button>

          <div className="cus-hdr-title-wrap">
            <h4 className="cus-hdr-header-title">Dashboard</h4>
          </div>
        </div>

        <div className="cus-hdr-header-right">

          <div className="cus-hdr-notif-wrap">
            <button
              className="cus-hdr-icon-btn"
              onClick={() => navigate('/customer/cus-notifications')}
            >
              <Bell size={18} />
              {unreadCount > 0 && (
                <span className="cus-hdr-notif-dot">{unreadCount}</span>
              )}
            </button>
          </div>

          <div className="cus-hdr-profile-wrap" ref={dropdownRef}>
            <button
              className="cus-hdr-profile-btn"
              onClick={() => setShowDropdown(prev => !prev)}
            >
              <div className="cus-hdr-avatar">
                {user.avatar ? (
                  <img src={user.avatar} alt={user.name} className="cus-hdr-avatar-img" />
                ) : (
                  <span className="cus-hdr-avatar-initials">{getInitials(user.name)}</span>
                )}
                <span className="cus-hdr-avatar-online" />
              </div>

              <div className="cus-hdr-user-info d-none d-md-block">
                <span className="cus-hdr-user-name">{user.name}</span>
                {user.email && (
                  <span className="cus-hdr-user-email">{user.email}</span>
                )}
              </div>

              <ChevronDown
                size={15}
                className={`cus-hdr-chevron ${showDropdown ? 'cus-hdr-chevron-open' : ''}`}
              />
            </button>

            {showDropdown && (
              <div className="cus-hdr-dropdown">
                <div className="cus-hdr-dropdown-header">
                  <div className="cus-hdr-dd-avatar">
                    {user.avatar ? (
                      <img src={user.avatar} alt={user.name} className="cus-hdr-avatar-img" />
                    ) : (
                      <span className="cus-hdr-avatar-initials">{getInitials(user.name)}</span>
                    )}
                  </div>
                  <div>
                    <p className="cus-hdr-dd-name">{user.name}</p>
                    <p className="cus-hdr-dd-email">{user.email || 'No email found'}</p>
                  </div>
                </div>

                <div className="cus-hdr-dropdown-divider" />

                <button className="cus-hdr-dd-item" onClick={() => { setShowDropdown(false); navigate('/customer/profile'); }}>
                  <User size={15} />
                  My Profile
                </button>
                <button className="cus-hdr-dd-item" onClick={() => { setShowDropdown(false); navigate('/customer/settings/notifications'); }}>
                  <Settings size={15} />
                  Settings
                </button>

                <div className="cus-hdr-dropdown-divider" />

                <button className="cus-hdr-dd-item cus-hdr-dd-logout" onClick={handleLogout}>
                  <LogOut size={15} />
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;